import { store } from "../store";
import DataStructure, { sanitize } from "./DataStructure";
import { deepFreeze, formatCurrency } from "../util/misc";
import { forEach, isEmpty, last } from "lodash";
import { diff } from "deep-object-diff";

export const CONTACT_BALANCE_FIELDS = {
  total: 0,
  for: {},
};
deepFreeze(CONTACT_BALANCE_FIELDS);

export default class ContactBalance extends DataStructure {
  constructor(id, data = {}) {
    data = sanitize(data, CONTACT_BALANCE_FIELDS);
    super(data);
    this.id = id;
  }

  // Database

  get path() {
    return ContactBalance.getPath(this.id);
  }

  static getPath(id) {
    let path = "balances";
    if (id) {
      path += `/${id}`;
    }
    return path;
  }

  static toFirestore(balance) {
    return balance.data;
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new ContactBalance(snapshot.id, data);
  }

  // Editing

  get isEmpty() {
    return isEmpty(diff(this.data, CONTACT_BALANCE_FIELDS));
  }

  isEqual(balance) {
    return isEmpty(diff(this.data, balance.data));
  }

  // Formatting

  get total() {
    return (this.data.total < 0 ? "+" : "") + formatCurrency(-this.data.total);
  }

  get for() {
    const entities = [];
    forEach(this.data.for, (entity, id) => {
      let formatted = {
        id,
        type: entity.type,
        amount: formatCurrency(entity.amount),
        entity: null,
      };
      // These lazy loads are fire-and-forget: the entity renders once the
      // fetch lands in the store. A dangling reference makes GET_DOC reject,
      // and this getter runs on every render, so the rejection has to be
      // swallowed here or it repeats for as long as the balance is shown.
      switch (entity.type) {
        case "salesLead":
          formatted.entity = store.state.main.salesLeads[id];
          if (!formatted.entity) {
            store.dispatch("GET_SALES_LEAD", id).catch(() => {});
          }
          break;
        case "sale":
          formatted.entity = store.state.main.sales[id];
          if (!formatted.entity) {
            store
              .dispatch("GET_SALE", {
                projectID: id.slice(0, -1),
                saleID: id.slice(-1),
              })
              .catch(() => {});
          }
          break;
        case "bill":
          formatted.entity = store.state.main.bills[last(id.split("-"))];
          if (!formatted.entity) {
            let [projectID, saleID, orderID, billID] = id.split("-");
            store
              .dispatch("GET_BILL", { projectID, saleID, orderID, billID })
              .catch(() => {});
          }
          break;
        case "paycheck":
          formatted.entity = store.state.main.paychecks[id];
          if (!formatted.entity) {
            store
              .dispatch("GET_PAYCHECK", { userID: this.id, paycheckID: id })
              .catch(() => {});
          }
          break;
      }
      entities.push(formatted);
    });
    return entities;
  }
}
